import React from 'react';
import { Dialog, Button, DialogActions,DialogContent, DialogContentText, DialogTitle, Slide, Box, Typography, List, ListItem } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ContactPrivacyPolicy = ({open, onClose}) => {

  const privacyPolicy = [
    {
      name:'Information we collect',
      text:'We may collect personal information that you voluntarily provide to us, including but not limited to:',
      bullet:['Full Name', 'Email Address', 'Phone Number', 'Any other contact information you provided']
    },
    {
      name:'How we use your information',
      text:'We use the information you provide to:',
      bullet:['Communicate wit you regarding our products, services, promotions, or inquiries', 'Provide, operate, and improve our Services', 'Respond to customer service request and support needs', 'Comply with legal obligations'],
      text2:'By providing your contact information, you expressly consent to us reaching out to you via email, phone, text message, or other communication channels for purposes related to our Services, marketing, or support.'
    },
    {
      name:'Data Sharing and Disclosure',
      text:'We do not sell, rent, lease, or otherwise disclose your personal information to third parties for their marketing or commercial purposes. \n\n We may disclose your information only in the following limited circumstances:',
      bullet:[
        'To trusted service providers working on our behalf under confidentiality agreements (e.g, hosting, analytics, communications)',
        'To comply with our legal obligations, law enforcement requests, or enforce our terms of use',
        'To protect our rights, property, or safety or that of our users or the public'
      ],
      text2:'All disclosures are made in accordance with applicable data protection laws.'
    },
    {
      name:'Data Security',
      text:'We implement appropriate technical and organizational measures to protect your presonal data from unauthorized access, disclosure, alteration, and destruction'
    },
    {
      name:'Your Rights and Choices',
      text:'You may:',
      bullet:[
        'Opt out of marketing communications at any time by following the unsubscribe link in our emails or contacting us directly.',
        'Request access to, correction of, or deletion of your personal information, subject to any legal obligations we may have to retain certain data.'
      ]
    },
    {
      name:'Data Retention',
      text:'We retain your personal data only as long as necessary to fulfill the purposes described in this policy, unless a longer retention period is required or permitted by law.'
    },
    {
      name:'Changes to this privacy policy',
      text:'We may update this privacy policy from time-to-time. We encourage you to review it periodically. Continued use of our Services after changes constitutes acceptance of the revised policy'
    },
    {
      name:'Contact Us',
      text:'If you have any questions or concerns about this Privacy Policy or our practices, please contact us directly'
    }
  ]

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="PanguPrivacyPolicy"
      >
        <DialogTitle
          sx={{
            fontSize:'2rem',
            fontWeight:'1000',
            fontFamily:'var(--title-font)'
          }}
        >{"Pangu Enterpises Incorporated Privacy Policy"}</DialogTitle>
        <DialogContent>
        <DialogContentText id="PanguPrivacyPolicy">
          {privacyPolicy.map((item, index) => (
            <Box
              key={index} // Add a unique key for each Box  
              sx={{
                paddingY: '1rem',
              }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontFamily: 'var(--title-font)',
                  fontSize: '2rem',
                  fontWeight: '500',
                  textTransform: 'capitalize',
                }}
              >
                {item.name}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'var(--text-font)',
                  fontSize: '1rem',
                }}
              >
                {item.text.split('\n').map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </Typography>
              {item.bullet && (
                <List>
                  {item.bullet.map((bulletPoint, bulletIndex) => (
                    <ListItem
                      key={bulletIndex}
                      sx={{
                        listStyleType: 'disc',
                        listStylePosition: 'inside',
                        display: 'list-item',
                      }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'var(--text-font)',
                          fontSize: '1rem',
                        }}
                      >
                        {bulletPoint}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              )}
              {item.text2 && (
                <Typography
                  sx={{
                    fontFamily: 'var(--text-font)',
                    fontSize: '1rem',
                  }}
                >
                  {item.text2.split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </Typography>
              )}
            </Box>
          ))}
        </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

export default ContactPrivacyPolicy